<!--历史值-->
<template>
  <div class="historyValueBody">
    <el-tabs v-model="activeName">
      <el-tab-pane label="历史列表" name="first">
        <historyValue></historyValue>
      </el-tab-pane>
      <el-tab-pane label="历史曲线" name="second">
        <historyCurve></historyCurve>
      </el-tab-pane>
    
    </el-tabs>
  </div>
</template>

<script type="text/javascript">
  import iconButton from '@/components/module/universal/iconButton.vue'
  import multipleSelection from '@/components/module/selection/multipleSelection.vue'
  import timeintervalselection from '@/components/module/selection/timeIntervalSelection.vue'
  import historyCurve from './historyCurve.vue'
  import historyValue from './historyValue.vue'
  import request from "@/api/http.js";
  export default {
    components: {
      iconButton,
      multipleSelection,
      timeintervalselection,
      historyCurve,
      historyValue
    },
    props: [],
    data () {
      return {
        //合并表格
        activeName: 'first',
      }
    },
    methods: {}
  }
</script>

<style scoped lang="scss">
  .box {
    background: #fff;
    display: block;
    height: 89%;
    width: 100%;
  }

  .monthReportBody {
    width: 100%;
    height: 100%;
    display: flex;
  }

  // .el_Tree_Body {
  // 	padding: 0 !important;
  // 	    height: 94.5%;
  // 		border-top: 0;
  // 		border-bottom: 0;
  // }


  .monreportLeft {
    height: 99%;
  }

  .monreportRigth {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  // /deep/.el-tree {
  // 	width: 2.65rem !important;
  //      min-width: 2.55rem !important;
  // }
  .historyValueBody {
    width: 100%;
    background-color: #fff;
    padding: 0 10px;

  }
</style>